import { AgencyConstants } from 'features/Agency/agencyHelper';
import AgencyReconciliationListView from 'features/Agency/components/AgencyReconciliationListView';
import AgencyReconciliationDetailScreen from 'features/Agency/screens/AgencyReconciliationDetailScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';

InvestorReconciliationReport.propTypes = {};

function InvestorReconciliationReport(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route
            path=""
            element={
              <AgencyReconciliationListView
                showFullUI={true}
                initialRole={AgencyConstants.AgencyRole.INVESTOR}
              />
            }
          />
          <Route path="/:reconciliationId" element={<AgencyReconciliationDetailScreen />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default InvestorReconciliationReport;
